import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { id: 'today', label: '今日爆料榜' },
  { id: 'celebrity', label: '明星绯闻' },
  { id: 'influencer', label: '网红黑料' },
  { id: 'timeline', label: '吃瓜时间线' },
  { id: 'featured', label: '吃瓜精选' },
  { id: 'channels', label: '爆料频道' },
  { id: 'faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span
              className={`font-heading text-xl font-black tracking-wide transition-colors ${
                scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              爆料网
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => goTo(link.id)}
                className={`px-3 py-2 text-sm font-medium rounded-md cursor-pointer transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-100 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => goTo('subscribe')}
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-notification-3-line"></i>
              订阅爆料
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
                scrolled || menuOpen ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
              }`}
            >
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => goTo(link.id)}
                className="flex items-center justify-between py-3 text-sm font-medium text-foreground-800 border-b border-background-200 last:border-b-0 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </button>
            ))}
            <button
              type="button"
              onClick={() => goTo('subscribe')}
              className="mt-3 mb-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer"
            >
              <i className="ri-notification-3-line"></i>
              订阅爆料
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}